/**
 * Licensed Materials - Property of ROOTCLOUD
 * THIS MODULE IS "RESTRICTED MATERIALS OF ROOTCLOUD"
 * (c) Copyright ROOTCLOUD Inc. 2021 All Rights Reserved
 *
 * The source code for this program is not published or
 * otherwise divested of its trade secrets
 */
/*
 * @Author: wangjx
 * @LastEditors: wangjx
 * @Date: 2021-11-19 10:39:03
 * @LastEditTime: 2021-12-31 10:38:17
 * @Description: file content
 */

// 0--隐藏 2--只读 3--可以操作
export function getExtendLabel(code, permissionList) {
  let label = null;
  if (permissionList && permissionList instanceof Array && permissionList.length > 0) {
    permissionList.forEach((element) => {
      if (code === element.resourceElementCode) {
        label = item.resourceElementExtendLabel || item.resourceElementLabel;
      }
    });
  }
  return label;
}


/**
 * 检测是否隐藏
 * 1--隐藏 2--只读 3--可以操作
 */
export function visibleRes(code, permissionList) {
  let visible = true;
  if (Array.isArray(permissionList) && permissionList.length) {
    permissionList.forEach((item) => {
      if (Array.isArray(code)) {
        code.forEach(codeItem => {
          if (codeItem === item.resourceElementCode && item.permission === 1) {
            visible = false;
          }
        });
      } else if (code === item.resourceElementCode && item.permission === 1) {
        visible = false;
      }
    });
  }
  return visible;
}

/**
 * 检测是否禁用
 */
export function disableRes(code, permissionList) {
  let isDisable = false;
  if (Array.isArray(permissionList) && permissionList.length) {
    permissionList.forEach((item) => {
      if (Array.isArray(code)) {
        code.forEach(codeItem => {
          if (codeItem === item.resourceElementCode && [1, 2].includes(item.permission)) {
            isDisable = true;
          }
        });
      } else if (code === item.resourceElementCode && [1, 2].includes(item.permission)) {
        isDisable = true;
      }
    });
  }
  return isDisable;
}

export function getResLabel(code, permissionList) {
  let label = "";
  if (Array.isArray(permissionList) && permissionList.length) {
    permissionList.forEach((item) => {
      if (code === item.resourceElementCode) {
        label = item.resourceElementExtendLabel || item.resourceElementLabel;
      }
    });
  }
  return label;
}

